function setEventListeners ( ) 
{
    startAccordian( );

    window.addEventListener( 'resize', function ( )
    {
        var currentWidth = window.innerWidth;
        if ( currentWidth > 769 )
        {
            var subsections = document.querySelectorAll( '.toc__subsections' );
            subsections.forEach( subsections =>
            {
                subsections.style.maxHeight = subsections.scrollHeight + "px";
            });
        }
        else
        {
            var subsections = document.querySelectorAll( '.toc__subsections' );
            subsections.forEach( subsections =>
            {
                subsections.style.maxHeight = null;
            });
            var closeBtns = document.querySelectorAll( ".toc__section__close" )
            closeBtns.forEach( closeBtn =>
            {
                closeBtn.classList.remove( "'toc__section__close--active" );
            });
        }
    });
}

function startAccordian ( )
{
    var sections = document.getElementsByClassName( 'toc__section__close' );
    for ( var i = 0; i < sections.length; i++ )
    {
        sections[ i ].addEventListener( "click", function( ) 
        {
            var subsections = this.parentElement.nextElementSibling;
            var close = this;
            if ( subsections.style.maxHeight )
            {
                subsections.style.maxHeight = null;
                close.classList.remove( 'toc__section__close--active' );
            }
            else
            {
                subsections.style.maxHeight = subsections.scrollHeight + "px";
                close.classList.add( 'toc__section__close--active' );
            }
        });
    }
}

setEventListeners( );